var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultoraenBpMparaPequeasEmpresas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 455.056 455.055",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M29.611,291.217c0,0,9.741,1.945,25.637,4.776l0.275-42.237c0.022-3.461,2.699-5.844,5.979-5.322l33.552,5.333 c3.279,0.521,5.92,3.75,5.896,7.211l-0.277,42.551c12.546,1.928,26.097,3.879,40.088,5.687l0.272-41.865 c0.023-3.462,2.7-5.845,5.979-5.323l33.551,5.333c3.279,0.521,5.92,3.75,5.897,7.211l-0.259,39.719 c38.646,3.548,76.121,4.742,101.24,0.271c3.198-0.57,1.728-42.134-37.581-98.7c-6.833-9.833,51.792-1.583,63.61,91.614 c42.581-16.209,74.39-55.272,68.786-86.893C368.721,144.071,319.7,93.687,243.455,77.92C107.895,49.879,12.073,118.247,0.4,250.19 C-1.743,274.215,4.267,286.332,29.611,291.217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M406.96,244.528c-31.965,71.795-91.872,90.827-159.196,90.867c-64.006,0.037-198.37-24.344-224.245-30.344 s-27.492-2.15-16.471,4.188c68.346,39.312,239.93,81.387,355.102,73.052c46.011-3.326,75.012-39.338,91.024-80.609 C465.481,269.958,413.627,230.653,406.96,244.528z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultoraenBpMparaPequeasEmpresas);
export default __webpack_public_path__ + "static/media/Consultoría en BPM para Pequeñas Empresas.6473f567558f4076efd867b46bf003de.svg";
export { ForwardRef as ReactComponent };